import { IReportDetailsDTO } from '../../../../../api/reports.dao';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ReportFormVM } from './report-form.viewmodel';
import { ReportFormPresentation } from './_report-form-presentation/report-form-presentation';

interface IProps {
    saveCompletedCallback: () => void;
    deleteCompletedCallback: () => void;
    reportData?: IReportDetailsDTO;
    eventId: number;
    accountId: number;
}

const ReportFormContainer = withViewModel(
    ReportFormPresentation,
    (props: IProps) => {
        const {
            saveCompletedCallback,
            deleteCompletedCallback,
            reportData,
            eventId,
            accountId,
        } = props;

        const formVM = new ReportFormVM(
            eventId,
            accountId,
            saveCompletedCallback,
            deleteCompletedCallback,
            reportData
        );
        return formVM;
    }
);

export { ReportFormContainer as ReportForm };
